/**
 * BRIGHT STAR FIREWORKS - Product Page Style Override v3
 * With inline pricing, boxed SOLD OUT, larger fonts
 */

(function() {
  'use strict';
  
  function applyStyles() {
    
    // ========================================
    // PRICE CONTAINER - Make inline layout
    // ========================================
    var priceContainers = document.querySelectorAll('#product-price, .price, .price__pricing-group');
    priceContainers.forEach(function(el) {
      el.style.setProperty('display', 'flex', 'important');
      el.style.setProperty('flex-direction', 'row', 'important');
      el.style.setProperty('align-items', 'center', 'important');
      el.style.setProperty('gap', '16px', 'important');
      el.style.setProperty('flex-wrap', 'wrap', 'important');
    });
    
    // Sale price (the main visible price $600.00) - WHITE
    var salePrices = document.querySelectorAll('.price-item--sale');
    salePrices.forEach(function(el) {
      el.style.setProperty('color', '#ffffff', 'important');
      el.style.setProperty('font-size', '26px', 'important');
      el.style.setProperty('font-weight', '600', 'important');
      el.style.setProperty('background', 'transparent', 'important');
    });

    // Regular price (products without compare price)
var regularPrices = document.querySelectorAll('.price--listing .price-item--regular:not(.price__sale .price-item--regular)');
regularPrices.forEach(function(el) {
  el.style.setProperty('color', '#ffffff', 'important');
  el.style.setProperty('font-size', '26px', 'important');
  el.style.setProperty('font-weight', '600', 'important');
  el.style.setProperty('background', 'transparent', 'important');
});
    
    // Compare/Regular price ($810.00) - RED strikethrough
    var comparePrices = document.querySelectorAll('.price__sale .price-item--regular, s .price-item--regular');
    comparePrices.forEach(function(el) {
      el.style.setProperty('color', '#ef4444', 'important');
      el.style.setProperty('font-size', '18px', 'important');
      el.style.setProperty('font-weight', '500', 'important');
      el.style.setProperty('text-decoration', 'line-through', 'important');
    });
    

    
    // ========================================
    // QUANTITY - Theme uses .qty-selection with .up/.down links
    // ========================================
    
    // The +/- buttons are <a> tags with classes .up and .down
    var qtyButtons = document.querySelectorAll('.qty-selection .up, .qty-selection .down, a.up, a.down, .quantity-control-up, .quantity-control-down');
    qtyButtons.forEach(function(el) {
      el.style.setProperty('background', '#1e293b', 'important');
      el.style.setProperty('background-color', '#1e293b', 'important');
      el.style.setProperty('border', '1px solid rgba(212, 160, 23, 0.4)', 'important');
      el.style.setProperty('color', '#f5b942', 'important');
      el.style.setProperty('width', '44px', 'important');
      el.style.setProperty('height', '44px', 'important');
      el.style.setProperty('font-size', '20px', 'important');
      el.style.setProperty('font-weight', '700', 'important');
      el.style.setProperty('cursor', 'pointer', 'important');
      el.style.setProperty('display', 'inline-flex', 'important');
      el.style.setProperty('align-items', 'center', 'important');
      el.style.setProperty('justify-content', 'center', 'important');
      el.style.setProperty('text-decoration', 'none', 'important');
      el.style.setProperty('line-height', '1', 'important');
    });
    
    // Quantity input
    var qtyInputs = document.querySelectorAll('.qty-selection input.quantity, input[id^="qty-"], .qty-selection input[name="quantity"]');
    qtyInputs.forEach(function(el) {
      el.style.setProperty('background', '#0B1220', 'important');
      el.style.setProperty('background-color', '#0B1220', 'important');
      el.style.setProperty('border', '1px solid rgba(212, 160, 23, 0.4)', 'important');
      el.style.setProperty('border-left', 'none', 'important');
      el.style.setProperty('border-right', 'none', 'important');
      el.style.setProperty('color', '#ffffff', 'important');
      el.style.setProperty('width', '50px', 'important');
      el.style.setProperty('height', '44px', 'important');
      el.style.setProperty('text-align', 'center', 'important');
      el.style.setProperty('font-size', '16px', 'important');
      el.style.setProperty('font-weight', '600', 'important');
    });
    
    // ========================================
    // SHIPPING ICONS - Invert to gold/white
    // ========================================
    var shippingIcons = document.querySelectorAll('.shipping-section img, .shipping-images img');
    shippingIcons.forEach(function(el) {
      el.style.setProperty('filter', 'invert(75%) sepia(50%) saturate(500%) hue-rotate(5deg) brightness(1.1)', 'important');
      el.style.setProperty('width', '30px', 'important');
      el.style.setProperty('height', '30px', 'important');
    });
    
    // ========================================
    // WEIGHT - INLINE layout with icon
    // ========================================
    var weightContainers = document.querySelectorAll('.product__section-weight, .weight-info, [class*="weight"]:not([class*="font-weight"])');
    weightContainers.forEach(function(el) {
      if (el.className && el.className.includes('font-weight')) return;
      el.style.setProperty('display', 'flex', 'important');
      el.style.setProperty('flex-direction', 'row', 'important');
      el.style.setProperty('align-items', 'center', 'important');
      el.style.setProperty('justify-content', 'center', 'important');
      el.style.setProperty('gap', '10px', 'important');
    });
    
    var weightValues = document.querySelectorAll('[data-weight-with-unit]');
    weightValues.forEach(function(el) {
      el.style.setProperty('color', '#ffffff', 'important');
      el.style.setProperty('font-size', '18px', 'important');
      el.style.setProperty('font-weight', '600', 'important');
      
      // Make parent INLINE
      var parent = el.parentElement;
      if (parent) {
        parent.style.setProperty('display', 'flex', 'important');
        parent.style.setProperty('flex-direction', 'row', 'important');
        parent.style.setProperty('align-items', 'center', 'important');
        parent.style.setProperty('justify-content', 'center', 'important');
        parent.style.setProperty('gap', '10px', 'important');
        
        // Add weight icon if not present
        if (!parent.querySelector('.bs-weight-icon')) {
          var iconSpan = document.createElement('span');
          iconSpan.className = 'bs-weight-icon';
          iconSpan.style.cssText = 'display: inline-flex; align-items: center;';
          iconSpan.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f5b942" stroke-width="2"><path d="M12 3a4 4 0 0 0-4 4c0 .74.21 1.43.57 2.02L3 21h18l-5.57-11.98c.36-.59.57-1.28.57-2.02a4 4 0 0 0-4-4z"/><circle cx="12" cy="7" r="1"/></svg>';
          parent.insertBefore(iconSpan, parent.firstChild);
        }
        
        // Style the label
        var label = parent.querySelector('label');
        if (label) {
          label.style.setProperty('color', '#f5b942', 'important');
          label.style.setProperty('font-size', '14px', 'important');
          label.style.setProperty('text-transform', 'uppercase', 'important');
          label.style.setProperty('letter-spacing', '0.1em', 'important');
          label.style.setProperty('margin', '0', 'important');
        }
      }
    });
    
    // ========================================
    // INCREASE FONT SIZE - Category & Description
    // ========================================
    
    // Category sidebar links
    var categoryLinks = document.querySelectorAll('.collection-custom-navigation a, .sidebar a, .collection-sidebar a');
    categoryLinks.forEach(function(el) {
      el.style.setProperty('font-size', '15px', 'important');
    });
    
    // Product description text
    var descriptionText = document.querySelectorAll('.product__section--desc, .product__section--desc p, .product-description, .product-description p, .rte p, .bs-product-description p');
    descriptionText.forEach(function(el) {
      el.style.setProperty('font-size', '16px', 'important');
      el.style.setProperty('line-height', '1.7', 'important');
    });
    
    // Product lists in description
    var descriptionLists = document.querySelectorAll('.product__section--desc li, .rte li, .bs-product-description li');
    descriptionLists.forEach(function(el) {
      el.style.setProperty('font-size', '16px', 'important');
      el.style.setProperty('line-height', '1.6', 'important');
    });
    
    // Category header
    var categoryHeaders = document.querySelectorAll('.collection-custom-navigation h5, .sidebar h5, .sidebar-title');
    categoryHeaders.forEach(function(el) {
      el.style.setProperty('font-size', '16px', 'important');
      el.style.setProperty('font-weight', '700', 'important');
    });
  }
  
  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyStyles);
  } else {
    applyStyles();
  }
  
  // Run again after delays
  setTimeout(applyStyles, 300);
  setTimeout(applyStyles, 600);
  setTimeout(applyStyles, 1000);
  setTimeout(applyStyles, 2000);
  
  // Watch for changes
  var observer = new MutationObserver(function() {
    setTimeout(applyStyles, 50);
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });
  
})();
